import { Link } from 'found'
import React, { Component } from 'react'

import Row from '../../components/row'
// import Column from '../../components/column'

import Article from './article'

import arrowIcon from '../../images/arrow.svg'
// import chevronRight from '../../images/chevron-right.svg'
// import nycImage from '../../images/nyc.png'

function Promotion({ action, title, link, color, image }) {

    return (
        <div className="column-39 w-col w-col-3">
            <Link to={link} style={{ background: color }} className="link-explore-ny w-inline-block">
                <div style={{ textTransform: 'uppercase' }} className="text-block-15">{action}&nbsp;</div>
                <div style={{ textTransform: 'uppercase' }} className="text-block-16">{title}</div>
                <img alt="" src={image} width={100} className="image-28" />
            </Link>
        </div>
    )
}

class ArticleSection extends Component {

    constructor() {
        super()
        this.state = { rows: 2, isMenuOpened: false }
    }

    render() {
        const { title, link, classPrefix, dropdownItems, articles, left, right, promotion } = this.props
        const canLoadMore = articles.length > (this.state.rows * 4 - 2)
        return (
            <div className={`${classPrefix}-latest`}>
                <div className="div-block-141">
                    <div className="section-title">
                        <div
                            data-hover={1}
                            data-delay={0}
                            className="dropdown-cities w-dropdown"
                            onMouseEnter={() => this.setState({ isMenuOpened: true })}
                            onMouseLeave={() => this.setState({ isMenuOpened: false })}
                            onClick={() => this.setState({ isMenuOpened: !this.state.isMenuOpened })}
                        >
                            <div className="dropdown-toggle-section w-dropdown-toggle">
                                <Link to={link} className={classPrefix}>{title}</Link>
                                <img alt="" src={arrowIcon} width={14} className="image-20" />
                            </div>
                            <nav
                                className="dropdown-list w-dropdown-list"
                                style={{ display: this.state.isMenuOpened ? 'flex' : 'none' }}
                            >
                                {dropdownItems.map((i, k) =>
                                    <Link
                                        key={k}
                                        to={i.link}
                                        className="cities-dropdown-link w-dropdown-link"
                                    >
                                        {i.name}
                                    </Link>
                                )}
                            </nav>
                        </div>
                    </div>
                    <Row size="15">
                        {articles.slice(0, 3).map((a, i) => <Article key={i} {...a} />)}
                    </Row>
                    <Row size="14">
                        {left && promotion && <Promotion {...promotion} />}
                        {articles.slice(3, 6).map((a, i) => <Article key={i} small {...a} />)}
                        {right && promotion && <Promotion {...promotion} />}
                    </Row>
                    {Array(this.state.rows - 2).fill().map((_, r) => {
                        return (
                            <Row key={r} size="14">
                                {articles.slice(4 * r + 6, 4 * r + 10).map((a, i) =>
                                    <Article key={i} small {...a} />
                                )}
                            </Row>
                        )}
                    )}
                    <div className="container-5 w-container">
                        <div
                            style={{ display: canLoadMore ? 'block' : 'none' }}
                            className="discover-more w-button"
                            onClick={() => this.setState({ rows: this.state.rows + 1 })}
                        >
                            DISCOVER&nbsp;MORE
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default ArticleSection
